import { forwardRef } from 'react';
import {
  alpha,
  Chip as MuiChip,
  chipClasses,
  ChipProps as MuiChipProps,
  styled,
} from '@mui/material';
import classNames from 'classnames';

import { isIconOption } from './Icon/iconOptions';
import { Icon, IconOption } from './Icon';

export type ChipProps = Omit<MuiChipProps, 'icon'> & {
  icon?: IconOption | MuiChipProps['icon'];
  multiline?: boolean;
  shape?: 'rounded' | 'square' | 'standard';
};

const StyledChip = styled(MuiChip)`
  &.shape {
    &__rounded {
      border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    }

    &__square {
      border-radius: 0;
    }
  }

  .${chipClasses.label} {
    line-height: 1 !important;
  }

  .${chipClasses.deleteIcon} {
    color: ${({ theme }) =>
      alpha(theme.palette.action.active, 1 - theme.palette.action.disabledOpacity)} !important;
  }

  &.multiline {
    height: auto;

    .${chipClasses.label} {
      white-space: normal;
    }

    &.${chipClasses.sizeMedium} {
      min-height: 24px;

      .${chipClasses.label} {
        padding-top: 3.25px;
        padding-bottom: 3.25px;
      }
    }

    &.${chipClasses.sizeMedium} {
      min-height: 32px;

      .${chipClasses.label} {
        padding-top: 6.25px;
        padding-bottom: 6.25px;
      }
    }
  }
`;

export const Chip = forwardRef<HTMLDivElement, ChipProps>(
  ({ className, icon, multiline, shape, ...rest }, ref) => (
    <StyledChip
      className={classNames(className, `shape__${shape}`, { multiline })}
      deleteIcon={<Icon name='close' />}
      icon={isIconOption(icon) ? <Icon name={icon} /> : icon}
      ref={ref}
      {...rest}
    />
  )
);

Chip.displayName = 'Chip';
